export const wrapperStyle = {
  display: "flex",
  minHeight: "100vh"
};

export const sidebarStyle = {
  flexShrink: 0,
  minHeight: "100vh",
  boxSizing: "border-box"
};

export const collapsedSidebarStyle = {
  width: "72px"
};

export const mainAreaStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh"
};

export const contentStyle = {
  flex: 1,
  padding: "var(--os-page-padding)",
  overflowX: "auto"
};
